import React, { useState } from 'react';

import { Avatar, Box } from '@mui/material';
import TextField from 'components/TextFieldWithIcon';
import Button from 'components/Button';

import {
  displayFlexAlignItemsCenterJustifyContentCenter,
  tokens
} from 'styles';
import searchSvg from 'assets/images/app/search.svg';

const Search = ({ placeholder, handleSearch, inputChange, setInputChange }) => {
  const handleChange = e => setInputChange(e.target.value);

  return (
    <Box
      {...displayFlexAlignItemsCenterJustifyContentCenter}
      width='100%'
      gap={'20px'}
      alignItems='stretch'
    >
      <TextField
        placeholder={placeholder}
        onChange={handleChange}
        value={inputChange}
        style={{
          paddingInline: '25px',
          width: '100%',
          minWidth: '300px'
        }}
        startIcon={
          <Avatar
            src={searchSvg}
            variant='square'
            sx={{
              width: '23px',
              height: '23px',
              '& img': {
                objectFit: 'contain'
              }
            }}
          />
        }
      />
      <Button
        variant='white'
        text='Search'
        onClick={handleSearch}
        token={tokens.FS16FW500LH19_2M}
        padding={'15px'}
        width='fit-content'
        style={{ minWidth: '140px' }}
      />
    </Box>
  );
};

export default Search;
